const directvapewholesale = {
    id: 'directvapewholesale',
    publicSiteName: 'Direct Vape Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#8428c0',
            secondary: '#080808',
            color1: '#ee2c7a',
            color2: '#f6a745',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/directvapewholesale/favicon.ico',
        logo: '/directvapewholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default directvapewholesale